import { __decorate, __metadata } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Directive } from '@angular/core';
import * as i1 from '@odx/angular';
import { WithDisabledState } from '@odx/angular';
import { CSSModifier, CSSComponent } from '@odx/angular/internal';
import { injectElement } from '@odx/angular/utils';

const ButtonSize = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};

const ButtonVariant = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    GHOST: 'ghost',
    HIGHLIGHT: 'highlight',
    SUCCESS: 'success',
    CONFIRMATION: 'confirmation',
    DANGER: 'danger',
};

/**
 * ButtonComponent is a customizable button element that supports various sizes and styles.
 * It uses the `WithDisabledState` host directive to provide disabled state management.
 *
 * @see {WithDisabledState}
 */
let ButtonComponent = class ButtonComponent {
    constructor() {
        this.element = injectElement();
        this.type = this.element.nativeElement.getAttribute('type');
        /**
         * The variant of the button.
         *
         * @type {ButtonVariant}
         * @default ButtonVariant.SECONDARY
         */
        this.variant = ButtonVariant.SECONDARY;
        /**
         * The size of the button.
         *
         * @type {ButtonSize}
         * @default ButtonSize.MEDIUM
         */
        this.size = ButtonSize.MEDIUM;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: ButtonComponent, isStandalone: true, selector: "button[odxButton], a[odxButton]", inputs: { variant: "variant", size: "size" }, host: { properties: { "attr.type": "type || \"button\"" } }, hostDirectives: [{ directive: i1.WithDisabledState }], ngImport: i0, template: "<ng-content select=\"odx-icon:not([alignRight])\" />\n<ng-content />\n<ng-content select=\"odx-icon[alignRight]\" />\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "variant", void 0);
__decorate([
    CSSModifier(),
    __metadata("design:type", Object)
], ButtonComponent.prototype, "size", void 0);
ButtonComponent = __decorate([
    CSSComponent('button')
], ButtonComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ standalone: true, selector: 'button[odxButton], a[odxButton]', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, hostDirectives: [WithDisabledState], host: {
                        '[attr.type]': 'type || "button"',
                    }, template: "<ng-content select=\"odx-icon:not([alignRight])\" />\n<ng-content />\n<ng-content select=\"odx-icon[alignRight]\" />\n" }]
        }], propDecorators: { variant: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class ResponsiveButtonDirective {
    constructor() {
        // eslint-disable-next-line @angular-eslint/no-input-rename
        this.breakpoint = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ResponsiveButtonDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: ResponsiveButtonDirective, isStandalone: true, selector: "[odxButton][odxResponsiveButton]", inputs: { breakpoint: ["odxResponsiveButton", "breakpoint"] }, host: { properties: { "attr.data-breakpoint": "breakpoint" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: ResponsiveButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: '[odxButton][odxResponsiveButton]',
                    host: {
                        '[attr.data-breakpoint]': 'breakpoint',
                    },
                }]
        }], propDecorators: { breakpoint: [{
                type: Input,
                args: ['odxResponsiveButton']
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, ButtonSize, ButtonVariant, ResponsiveButtonDirective };
